const INITIAL_STATE = {
    dadosCadastrais: null,
    esperandoRespostaSolicitacaoDados: false,
    loadingImpressao: false,
    erroExtrato: false,
    errorMsg: "",
    mensagem: ''
};

export default (state = INITIAL_STATE, action) => {

    switch (action.type){

        case 'PUT_NOME_SOCIAL':
            return {...state, esperandoRespostaSolicitacaoDados: true, mensagem: ''};

        case 'ALTERAR_NOME_SOCIAL_SUCCESS':
            return {...state, esperandoRespostaSolicitacaoDados: false, mensagem: ''};  

        case 'ALTERAR_NOME_SOCIAL_ERROR':
            return {...state, esperandoRespostaSolicitacaoDados: false, errorMsg: action.payload, mensagem: ''};                        

        case 'CNISPF_DADOS_CADASTRAIS_SOLICITADO':
            return {...state, esperandoRespostaSolicitacaoDados: true, mensagem: ''};

        case 'CNISPF_DADOS_CADASTRAIS_RECEBIDO':
            return {...state, dadosCadastrais: action.data, esperandoRespostaSolicitacaoDados: false, mensagem: ''};

        case 'CNISPF_ERRO_RECEBIDO':
            return {error: action.data, extratoCnis: null, loadingExtratoCnis: false, erroExtrato:true, mensagem: ''};

        case 'CNISPF_IMPRESSAO_SOLICITADA':
            return {...state, loadingImpressao: true, mensagem: ''}

        case 'ECNIS_IMPRESSAO_RECEBIDA':
            return {...state, loadingImpressao: false, mensagem: 'sucesso'}

        case 'ECNIS_ERRO_IMPRESSAO_RECEBIDA':
            return {...state, loadingImpressao: false, mensagem: ''}

        case 'ECNIS_LIMPAR_MENSAGEM':
            return {...state, loadingImpressao: false, mensagem: '', errorMsg: '', esperandoRespostaSolicitacaoDados: false}
        default:
            return state;
    }

}